"use strict";

exports.__esModule = true;
exports.DEFAULT_POST_QUOTES_SIZE_MOBILE = exports.DEFAULT_POST_HEADER_THREE_SIZE_MOBILE = exports.DEFAULT_POST_HEADER_TWO_FONT_SIZE_MOBILE = exports.DEFAULT_POST_PAGE_FONT_SIZE_MOBILE = exports.DEFAULT_POST_TITLE_FONT_SIZE_MOBILE = exports.BREAKPOINT_POST_CONTENT_AREA_SMALL = exports.BREAKPOINT_POST_CONTENT_AREA_MIN = exports.POST_CONTENT_AREA_MAX_WIDTH = exports.POST_CONTENT_AREA_MIN_WIDTH = exports.POST_PAGE_MAX_WIDTH = exports.POST_PAGE_MIN_WIDTH = exports.POST_PAGE_PADDING = exports.POST_PAGE_CONTAINER_PADDING = void 0;

var _variables = _interopRequireDefault(require("../styles/variables.scss"));

var _breakpoints = _interopRequireDefault(require("../styles/breakpoints.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var POST_PAGE_CONTAINER_PADDING = parseInt(_variables["default"].postPageContainerPadding, 10);
exports.POST_PAGE_CONTAINER_PADDING = POST_PAGE_CONTAINER_PADDING;
var POST_PAGE_PADDING = parseInt(_variables["default"].postPagePadding, 10);
exports.POST_PAGE_PADDING = POST_PAGE_PADDING;
var POST_PAGE_MIN_WIDTH = parseInt(_variables["default"].postPageMinWidth, 10);
exports.POST_PAGE_MIN_WIDTH = POST_PAGE_MIN_WIDTH;
var POST_PAGE_MAX_WIDTH = parseInt(_variables["default"].postPageMaxWidth, 10);
exports.POST_PAGE_MAX_WIDTH = POST_PAGE_MAX_WIDTH;
var POST_CONTENT_AREA_MIN_WIDTH = parseInt(_variables["default"].postContentAreaMinWidth, 10);
exports.POST_CONTENT_AREA_MIN_WIDTH = POST_CONTENT_AREA_MIN_WIDTH;
var POST_CONTENT_AREA_MAX_WIDTH = parseInt(_variables["default"].postContentAreaMaxWidth, 10);
exports.POST_CONTENT_AREA_MAX_WIDTH = POST_CONTENT_AREA_MAX_WIDTH;
var BREAKPOINT_POST_CONTENT_AREA_MIN = parseInt(_breakpoints["default"].breakpointPostContentAreaMin, 10);
exports.BREAKPOINT_POST_CONTENT_AREA_MIN = BREAKPOINT_POST_CONTENT_AREA_MIN;
var BREAKPOINT_POST_CONTENT_AREA_SMALL = parseInt(_breakpoints["default"].breakpointPostContentAreaSmall, 10);
exports.BREAKPOINT_POST_CONTENT_AREA_SMALL = BREAKPOINT_POST_CONTENT_AREA_SMALL;
var DEFAULT_POST_TITLE_FONT_SIZE_MOBILE = 26;
exports.DEFAULT_POST_TITLE_FONT_SIZE_MOBILE = DEFAULT_POST_TITLE_FONT_SIZE_MOBILE;
var DEFAULT_POST_PAGE_FONT_SIZE_MOBILE = 16;
exports.DEFAULT_POST_PAGE_FONT_SIZE_MOBILE = DEFAULT_POST_PAGE_FONT_SIZE_MOBILE;
var DEFAULT_POST_HEADER_TWO_FONT_SIZE_MOBILE = 24;
exports.DEFAULT_POST_HEADER_TWO_FONT_SIZE_MOBILE = DEFAULT_POST_HEADER_TWO_FONT_SIZE_MOBILE;
var DEFAULT_POST_HEADER_THREE_SIZE_MOBILE = 20;
exports.DEFAULT_POST_HEADER_THREE_SIZE_MOBILE = DEFAULT_POST_HEADER_THREE_SIZE_MOBILE;
var DEFAULT_POST_QUOTES_SIZE_MOBILE = 20;
exports.DEFAULT_POST_QUOTES_SIZE_MOBILE = DEFAULT_POST_QUOTES_SIZE_MOBILE;